import Button from "@/shared/form/button";
import { usePalette } from "@/shared/theme";
import { MailOutlined } from "@ant-design/icons";

export function PersonEmail({ email }: { email: string | null | undefined }) {
  const palette = usePalette();

  if (!email) {
    return null;
  }

  return (
    <Button
      href={`mailto:${email}`}
      type="default"
      size="small"
      className="!rounded-lg !text-xs"
      style={{
        color: palette.success[7],
        backgroundColor: palette.success[0],
        borderColor: palette.success[1],
      }}
      icon={<MailOutlined />}
    >
      {email}
    </Button>
  );
}
